/*---------------------------------------------------------*\
 * Imports
\*---------------------------------------------------------*/
import PubSub from 'pubsub-js';
import keyboard from 'keycode-ui';
import _ from 'lodash';

/*---------------------------------------------------------*\
 * Weakmaps
\*---------------------------------------------------------*/
const deps = {};

/*---------------------------------------------------------*\
 * PhotosHomeLandingController
\*---------------------------------------------------------*/
class PhotosHomeLandingController {
  //-----------------------------------
  // Constructor
  //-----------------------------------
  constructor($scope, $rootScope, $timeout, topics, navigationService, photos, localService, storageKeys, states,
              $state, $stateParams) {
    this.name = 'photosHomeLanding';

    deps.$state = $state;
    deps.$scope = $scope;
    deps.states = states;
    deps.$timeout = $timeout;
    deps.$stateParams = $stateParams;
    deps.topics = topics;
    deps.$rootScope = $rootScope;
    deps.navigationService = navigationService;
    deps.topics = topics;
    deps.$timeout = $timeout;

    this.photos = photos;
    this.$scope = $scope;
    this.slideshowOn = false;
    this.leftNavItems = [
      {
        id: 'news',
        title: 'News',
        state: deps.states.home,
        sections: []
      },
      {
        id: 'weather',
        title: 'Weather',
        state: deps.states.weather_center,
        sections: []
      },
      {
        id: 'traffic',
        title: 'Traffic',
        state: deps.states.traffic_center,
        sections: []
      }
    ];
    this.subnavMenuItems = [
      {
        title: 'Photos',
        id: 'photos'
      },
      {
        title: 'Slideshow: ' + (this.slideshowOn ? 'On' : 'Off'),
        id: 'slideshow'
      },
      {
        title: 'Change Region',
        id: 'regions'
      }
    ]; // TODO, render items dynamically
    this.currentRegion = deps.$stateParams.subRegion ? JSON.parse(deps.$stateParams.subRegion) :
      localService.get(storageKeys.selectedRegion);

    const token = PubSub.subscribe(topics.component.selectPhotos, (msn, data) => {
      this.images = data;
      this.photos.showImages = true;
    });
    const token1 = PubSub.subscribe(deps.topics.nav.enter, (msg, data) => {
      if (data.source === 'navbar') {
        // No matter what is chosen we always go back to the list view
        if (data.data.id !== 'slideshow') {
          this.photos.showImages = false;
        }

        if (data.data === this.subnavMenuItems[1]) {
          // TODO Add logic to toggle slide show and update display
          const item = data.data;
          this.slideshowOn = !this.slideshowOn;
          data.data.title = 'Slideshow: ' + (this.slideshowOn ? 'On' : 'Off');
          PubSub.publish(deps.topics.component.slideshowToggle, { data: item, slideshowOn: this.slideshowOn });
        } else {
          this.subNavSelect(data.data);
        }
        this.$scope.$apply();
      }
    });
    const token2 = PubSub.subscribe(deps.topics.state.reactivate, () => {
      if (deps.$rootScope.previousActiveElement) {
        // Restore focus to previously focused dom element
        deps.$timeout(() => {
          deps.$rootScope.previousActiveElement.focus();
          console.log(deps.$rootScope.previousActiveElement);
          delete deps.$rootScope.previousActiveElement;
        });
      }
    });

    this.subNavSelect(this.subnavMenuItems[0]);

    deps.$scope.$on('$destroy', () => {
      PubSub.unsubscribe(token);
      PubSub.unsubscribe(token1);
      PubSub.unsubscribe(token2);
    });
  }

  //-----------------------------------
  // Methods
  //-----------------------------------
  subNavSelect(item) {
    if (item) {
      this.activeSection = item;
      this.photos.showImages = false;

      // This initial timeout is necessary to wait for the old .main-content to have
      // been cleared from the DOM
      deps.$timeout(() => {
        deps.navigationService.focusElAsync('.main-content');
      });
    }
  }

  isActiveSection(section) {
    return section === this.activeSection.id;
  }

  onRegionSelect(region) {
    if (region) {
      deps.$state.go(deps.$state.$current, { subRegion: JSON.stringify(region) });
    }
  }

  onOtherRegionKeyDown(e, region, index) {
    if (keyboard.isUp(e)) {
      if (_.inRange(index, 0, 3)) {
        deps.navigationService.focusEl('navbar .selected');
        e.preventDefault();
      }
    }
  }
}

PhotosHomeLandingController.$inject = [
  '$scope',
  '$rootScope',
  '$timeout',
  'topics',
  'navigationService',
  'photos',
  'localService',
  'storageKeys',
  'states',
  '$state',
  '$stateParams'
];

export default PhotosHomeLandingController;



/** WEBPACK FOOTER **
 ** ./client/app/components/photosHomeLanding/photosHomeLanding.controller.js
 **/